import { render, staticRenderFns } from "./CatalogSelected.vue?vue&type=template&id=8bc967b6&scoped=true&"
import script from "./CatalogSelected.vue?vue&type=script&lang=js&"
export * from "./CatalogSelected.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSelected.vue?vue&type=style&index=0&id=8bc967b6&lang=scss&scoped=true&"
import style1 from "./CatalogSelected.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc967b6",
  null
  
)

export default component.exports